export default __webpack_public_path__ + "static/media/alert_high-intensity.3339e9de.ogg";